import Vue from 'vue'
import { ValidationObserver, ValidationProvider, extend, localize } from 'vee-validate'
import en from 'vee-validate/dist/locale/en.json'
import pl from 'vee-validate/dist/locale/pl.json'
import * as rules from 'vee-validate/dist/rules'
import store from './../store/index'

Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule])
})

extend('total_size', {
  validate (value, args) {
    let total = 0
    for (const file of value) {
      total = total + file.size
    }
    total = total / 1024
    if (total < args.size) {
      return true
    }
  },
  params: ['size']
})

const enTrans = en
enTrans.messages.total_size = 'The {_field_} field total size must be less than {size}KB'

const plTrans = pl
plTrans.messages.total_size = 'Łączny rozmiar plików {_field_} musi być mniej niż {size}KB'

Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)

localize({ en: enTrans, pl: plTrans })
localize(store.state.lang)
